import {
  Handle,
  Node,
  NodeProps,
  Position
} from '@xyflow/react';
import clsx from 'clsx';

import { AgentConfigStep, AgentConfigStepLabelEnum, AgentConfigStepTypeEnum } from '@/types/agent';

import { useAgentEdit } from '../state/agentEditContext';
import { getNodeTypeIcon } from '../util/nodeTypeUtils';
import styles from './node.module.scss';


export function LowCodeNode( { data }: NodeProps<Node<AgentConfigStep>> ) {
  const { stepHasValidationErrors } = useAgentEdit();
  const hasErrors = stepHasValidationErrors( data.id );

  const icon = getNodeTypeIcon( data.type );

  return (
    <div
      className={
        clsx( {
          [styles.agent_node]: data.type === AgentConfigStepTypeEnum.AGENT,
          [styles.api_node]: data.type === AgentConfigStepTypeEnum.API,
          [styles.llm_node]: data.type === AgentConfigStepTypeEnum.LLM,
          [styles.node_error]: hasErrors
        } )
      }
    >
      <Handle type="target" position={ Position.Left } id={ `${ data.id }-in` } />
      <div>
        <div className={ styles.header }>
          {icon} {data.id}
        </div>
        <div className={ styles.details }>{data.description}</div>
      </div>
      <Handle type="source" position={ Position.Right } id={ `${ data.id }-out` } />
    </div>
  );
}

export function BasicNode( { data }: NodeProps<Node<AgentConfigStep>> ) {
  const { stepHasValidationErrors } = useAgentEdit();
  const hasErrors = stepHasValidationErrors( data.id );
  const isEndNode = data.id === AgentConfigStepLabelEnum.END;
  const isStartNode = data.id === AgentConfigStepLabelEnum.START;

  return (
    <div
      className={
        clsx( styles.basicNode, {
          [styles.node_error]: hasErrors
        } )
      }
    >
      {
        !isStartNode && (
          <Handle type="target" position={ Position.Left } id={ `${ data.id }-in` } />
        )
      }
      <div>
        <div className={ styles.details }>{data.id}</div>
      </div>
      {
        !isEndNode && (
          <Handle type="source" position={ Position.Right } id={ `${ data.id }-out` } />
        )
      }
    </div>
  );
}
